import Reports from './Reports'

export default Reports



// WEBPACK FOOTER //
// ./src/views/Reports/index.js